<template>
    <div id="app" data-app>
        <router-view :key="$route.fullPath"/>
    </div>
</template>
<script>
export default{
}
</script>
